import EastIcon from '@mui/icons-material/East';
import DifferencesPopover from './DifferencesPopover';
import IssuesPopover from './IssuesPopover';
import { useState } from 'react';
import { Popover } from '@mui/material';

const getNewFieldOrOldFieldOrEmpty = (obj = {}, field) => {
  let value = obj[field];
  if (value === null || value === undefined) {
    value = obj[`${field}Og`];
  }
  if (value === null || value === undefined) {
    value = '';
  }
  return value;
};

const getCellClass = (item, field) => {
  if (item?.type === 'edited' && item?.changedKeys?.includes(field)) return 'edited-cell';
  if (item?.type === 'with-issues' && item?.issues?.some((issue) => issue?.field === field)) return 'with-issues-cell';
  return '';
};

const FormatsRow = ({ style, article, format, index }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <tr
      style={style}
      className={
        format?.type === 'edited'
          ? 'edited'
          : format?.type === 'created'
          ? 'created'
          : format?.type === 'with-issues' && 'with-issues'
      }
    >
      <td className={getCellClass(format, 'codeArticle')}>
        <div>
          {format?.type === 'with-issues' && (
            <IssuesPopover issues={format?.issues} excelRow={format?.excelRow} excelSheet={format?.excelSheet} />
          )}
          <span
            style={{
              width: '100%',
            }}
            aria-owns={open ? `mouse-over-popover-${index}` : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
          >
            {getNewFieldOrOldFieldOrEmpty(format, 'codeArticle') || <i>vacio</i>}
          </span>

          <Popover
            id={`mouse-over-popover-${index}`}
            sx={{ pointerEvents: 'none' }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',

                padding: '1rem',
              }}
            >
              <span>{article?.name}</span>
              <img
                src={
                  article?.imgFile
                    ? URL.createObjectURL(article?.imgFile)
                    : article?.imglink || article?.imgBase64 || '/Image_not_available.png'
                }
                alt="img"
                width="130rem"
              />
            </div>
          </Popover>
        </div>
      </td>
      <td className={getCellClass(format, 'codeFormat')}>
        <div>{getNewFieldOrOldFieldOrEmpty(format, 'codeFormat') || <i>vacio</i>}</div>
      </td>
      <td className={getCellClass(format, 'format')}>
        <div>
          {getNewFieldOrOldFieldOrEmpty(format, 'format')}
          <DifferencesPopover show={format?.type === 'edited' && format?.changedKeys?.includes('format')}>
            <div>
              <span>{format?.formatOg}</span> <EastIcon /> <span>{format?.format}</span>
            </div>
          </DifferencesPopover>
        </div>
      </td>
      <td className={getCellClass(format, 'materialName')}>
        <div>
          {format?.materialName}
          <DifferencesPopover show={format?.type === 'edited' && format?.changedKeys?.includes('materialName')}>
            <div>
              <span>{format?.materialNameOg}</span> <EastIcon /> <span>{format?.materialName}</span>
            </div>
          </DifferencesPopover>
        </div>
      </td>

      <td className={getCellClass(format, 'active')}>
        <div>{getNewFieldOrOldFieldOrEmpty(format, 'active') === true ? 'SI' : 'NO'}</div>
      </td>
      <td className={getCellClass(format, 'isCustom')}>
        <div>{getNewFieldOrOldFieldOrEmpty(format, 'isCustom') === true ? 'SI' : 'NO'}</div>
      </td>
    </tr>
  );
};

export default FormatsRow;
